import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "./slice/headerSlice";
import districtSlice from "./slice/districtSlice";
import yearSlice from "./slice/yearSlice";
import stateSlice from "./slice/stateSlice";
import blockSlice from "./slice/blockSlice";
import archiveServicesSlice from "./slice/archiveServicesSlice";
import enrollementFilterSlice from "./slice/enrolmentFilterSlice";
import archiveServicesSchoolProfileSlice from "./slice/archiveServicesSchoolProfileSlice";
import archiveServicesEnrolmentSlice from "./slice/archiveServicesEnrolmentSlice";
import archiveServicesCWSNEnrolmentSlice from "./slice/archiveServicesCWSNEnrolmentSlice";
import archiveServicesTeacherSlice from "./slice/archiveServicesTeacherSlice";
import archiveServicesClassesTaughtSlice from "./slice/archiveServicesClassesTaughtSlice";
import archiveServicesTeacherDisabilitySlice from "./slice/archiveServicesTeacherDisabilitySlice";
import archiveServicesTeacherTrainingSlice from "./slice/archiveServicesTeacherTrainingSlice";
import archiveServicesEnrolmentSummarisedSlice from "./slice/archiveServicesEnrolmentSummarisedSlice";
import archiveServicesEnrolmentStudentGPISlice from "./slice/archiveServicesEnrolmentStudentGPISlice";
import archiveServicesPtrYearSlice from "./slice/archiveServicesPtrYearSlice";
import archiveServicesYearSliceManagementWise from "./slice/archiveServicesYearSliceManagementWise";
import archiveServicesGraphSlice from "./slice/archiveServicesGraphSlice";
import archiveServicesPieGraphSlice from "./slice/archiveServicesPieGraphSlice";
import schoolFilterSlice from "./slice/schoolFilterSlice";
import schoolFilterSlice3016 from "./slice/schoolFilterSlice3016";
import darkLightMode from "./slice/darkLightModeSlice";
import dataGridAPISlice from "./slice/dataGridAPISlice";
import dashboardSlice from "./slice/dashboardSlice";
import dashboardFilterSlice from "./slice/dashboardFilter.slice";
import Column3016Slice from "./slice/Column3016Slice";
import DistBlockWiseSlice from "./slice/DistBlockWiseSlice";
import mapSlice from "./slice/mapSlice";
import dashboardTeacherStatSlice from "./slice/dashboardTeacherStatSlice";
import dashboardTeacherTrainedCWSNStatSlice from "./slice/dashboardTeacherTrainedCWSNStatSlice";
import dashboardSchoolStatsSlice from "./slice/dashboardSchoolStatsSlice";
import dashboardSchoolStatsYearSlice from "./slice/dashboardSchoolYearStatsSlice";
import dashboardStudentsSlice from "./slice/dashboardStudentsSlice";
import dashboardStudentsGPISlice from "./slice/dashboardStudentsGPIDataSlice";
import dashboardSchoolStatsIntSlice from "./slice/dashboardSchoolStatsIntSlice";
import dashboardStudentsIntSlice from "./slice/dashboardStudentsIntSlice";
import dashboardTeacherStatIntSlice from "./slice/dashboardTeacherStatIntSlice";
import dashboardAllStateSchemesSlice from "./slice/dashboardAllStateSchemesSlice";
import archiveServicesSocialCatSlice from "./slice/archiveServicesSocialCatSlice";
import archiveServicesPtRSlice from "./slice/archiveServicesPtRSlice";
import schoolFilter2007Slice from "./slice/schoolFilter2007Slice";
import DashBoardMapDataSlice from "./slice/DashBoardMapDataSlice";
import DashBoardSchoolsMapDataSlice from "./slice/DashBoardSchoolsMapDataSlice";
import DashBoardTeacherMapDataSlice from "./slice/DashBoardTeacherMapDataSlice";
import DashBoardTeacherTrainedMapDataSlice from "./slice/DashBoardTeacherTrainedMapDataSlice";
import DashBoardStudentsMapDataSlice from "./slice/DashBoardStudentsMapDataSlice";
import DashBoardStudentsGPIMapDataSlice from "./slice/DashBoardStudentsGPIMapDataSlice";
import DashBoardMapOtherDataSlice from "./slice/DashBoardMapOtherDataSlice";
import mapFilterSlice from "./slice/mapFilterSlice";
import enrollementSlice4014 from "./slice/enrolmentSlice4014";


const store = configureStore({
  reducer: {
    header: headerSlice,
    mapData: mapSlice,
    schoolFilter: schoolFilterSlice,
    enrollmentFilter: enrollementFilterSlice,
    schoolFilter3016: schoolFilterSlice3016,
    mapFilters:mapFilterSlice,
    schoolFilter2007Slice: schoolFilter2007Slice,
    state: stateSlice,
    distrct: districtSlice,
    block: blockSlice,
    year: yearSlice,
    school: archiveServicesSlice,
    schoolProfile: archiveServicesSchoolProfileSlice,
    enrolment: archiveServicesEnrolmentSlice,
    cwsnEnrolment: archiveServicesCWSNEnrolmentSlice,
    teacher: archiveServicesTeacherSlice,
    classesTaught: archiveServicesClassesTaughtSlice,
    teacherDisability: archiveServicesTeacherDisabilitySlice,
    teacherTraining: archiveServicesTeacherTrainingSlice,
    enrolmentSummarised: archiveServicesEnrolmentSummarisedSlice,
    enrolmentStudentGPI: archiveServicesEnrolmentStudentGPISlice,
    schoolgraph: archiveServicesGraphSlice,
    schoolPieGraph: archiveServicesPieGraphSlice,
    schoolsocialcat: archiveServicesSocialCatSlice,
    pupilteacherratio: archiveServicesPtRSlice,
    pupilteacherratioyear: archiveServicesPtrYearSlice,
    pupilteacherratioyearmanagement: archiveServicesYearSliceManagementWise,
    toggle: darkLightMode,
    column: dataGridAPISlice,
    column3016: Column3016Slice,
    dashboard: dashboardSlice,
    dashboardFilter: dashboardFilterSlice,
    distBlockWise: DistBlockWiseSlice,
    schoolStats: dashboardSchoolStatsSlice,
    schoolStatsYear: dashboardSchoolStatsYearSlice,
    teacherStats: dashboardTeacherStatSlice,
    teacherTrainedCWSNStats: dashboardTeacherTrainedCWSNStatSlice,
    MapStats: DashBoardMapDataSlice,
    MapSchoolsStats: DashBoardSchoolsMapDataSlice,
    MapTeacherStats: DashBoardTeacherMapDataSlice,
    MapTeacherTrainedStats: DashBoardTeacherTrainedMapDataSlice,
    MapStudentsStats: DashBoardStudentsMapDataSlice,
    MapStudentsGPIStats: DashBoardStudentsGPIMapDataSlice,
    MapStatsPercentage: DashBoardMapOtherDataSlice,
    studentStats: dashboardStudentsSlice,
    studentGPIStats: dashboardStudentsGPISlice,
    schoolIntStats: dashboardSchoolStatsIntSlice,
    teacherIntStats: dashboardTeacherStatIntSlice,
    studentIntStats: dashboardStudentsIntSlice,
    schemesAllState: dashboardAllStateSchemesSlice,
    enrollment4014 : enrollementSlice4014,

  },
});

export default store;
